import {
  Component,
  HostListener,
  OnInit,
  ElementRef,
  ViewChild,
  Input,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";
import { TranslateService } from "@ngx-translate/core";
import { Output, EventEmitter } from "@angular/core";
import * as data from "src/assets/json/header.json";
import { SidebarComponent } from "../../my-account/sidebar/sidebar.component";
import { BaseService } from "src/app/base/base.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  userInfo: any = {};
  changeTheme = false;
  languageData: any;
  language = "en";
  sub: any;
  isShow: boolean = false;
  activeUrl: any;
  @Input() redirectUrl: any;
  @Input() seriesUrl: any;
  @Input() category: any;
  @Input() musicplayer: any;
  @ViewChild("menu") menu: ElementRef;
  appConstant: any;
  headerMenu: any = (data as any).default;
  @Output() messageEvent = new EventEmitter<string>();
  @Output() Navigate = new EventEmitter();
  isOpened = false;
  name: string;
  activeStatus: any = "home";
  linkActive: any;
  opened = true;
  profile: any;
  constructor(
    public route: Router,
    private router: ActivatedRoute,
    public translate: TranslateService,
    public sidebarComponent: SidebarComponent,
    public service: BaseService
  ) {
    if (!localStorage.getItem(environment.localStorageLangKey)) {
      const language = "en";

      localStorage.setItem(
        environment.localStorageLangKey,
        JSON.stringify(language)
      );
    }
    this.userInfo = localStorage.getItem(environment.localStorageKey);
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    translate.setDefaultLang("en");
    if (encryptedData) {
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
          CryptoJS.enc.Utf8
        )
      );
    }
    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.languageData = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );

      this.language = this.languageData;
      translate.use(this.language);
    }
    // this.translate.onLangChange.subscribe((e: any) => {
    //   this.titleService.setTitle(e.translations.PAGE_TITLE);
    // });
    translate.addLangs(["en", "es"]);
  }

  ngOnInit(): void {
    const profileData = this.userInfo?.people_profile?.filter(
      (data) => data.id === this.userInfo?.profile_id
    );
    if (profileData) {
      this.service.profile = profileData[0];
    }
    if (this.redirectUrl) {
      this.linkActive = "videos";
    }
    if (this.seriesUrl) {
      this.linkActive = "shows";
    }
    if (this.category) {
      this.linkActive = "category";
    }
    if (this.musicplayer) {
      this.linkActive = this.musicplayer;
    }
    if (localStorage.getItem(environment.localStorageKey)) {
      if (this.route.url === "/") {
        this.route.navigate(["/home"]);
      }
    }
    this.router.queryParams.subscribe((params) => {
      if (params["data"]) {
        this.activeStatus = params["data"];
      } else {
        this.activeStatus = "/";
      }
    });
    const body = document.getElementsByTagName("body")[0];
    if (localStorage.getItem(environment.themeClass)) {
      body.classList.add("white-theme");
    } else {
      body.classList.remove("white-theme");
    }
    this.appConstant = environment;
    this.sub = this.router.data.subscribe((v) => (this.activeUrl = v.url));
  }
  changeProfile(data: any) {
    this.service.profile = data;
    this.userInfo.profile_id = data.id;
    const encryptData = CryptoJS.AES.encrypt(
      JSON.stringify(this.userInfo),
      environment.secretkey
    ).toString();
    localStorage.setItem(environment.localStorageKey, encryptData);
    this.onRefresh();
  }
  themeChange() {
    this.changeTheme = !this.changeTheme;
    const body = document.getElementsByTagName("body")[0];
    if (this.changeTheme) {
      localStorage.setItem(environment.themeClass, "white-theme");
      body.classList.add("white-theme");
    } else {
      localStorage.setItem(environment.themeClass, "");
      body.classList.remove("white-theme");
    }
  }
  errorHandler(event) {
    event.target.src = environment.userNoImage;
  }
  logOut() {
    this.service.logoutUser().subscribe(
      (res) => {
        if (res) {
          localStorage.clear();
          this.onRefresh();
          this.route.navigate(["/"]);
        }
      },
      (err) => {
        localStorage.clear();
        this.onRefresh();
        this.route.navigate(["/"]);
      }
    );
  }
  onRefresh() {
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    let currentUrl = this.route.url + "?";
    this.route.navigateByUrl(currentUrl).then(() => {
      this.route.navigated = false;
      this.route.navigate([this.route.url]);
    });
  }
  addClass() {
    this.opened = false;
    this.isShow = !this.isShow;
  }
  closeMenu() {
    this.isShow = false;
  }

  openSelect() {
    this.isShow = false;
    this.opened = true;
  }
  /**
   * Show popup when user don't have any subscription plan.
   */
  showPopup() {
    // if (localStorage.getItem(environment.localStorageKey)) {
    //   this.userInfo = JSON.parse(
    //     CryptoJS.AES.decrypt(
    //       localStorage.getItem(environment.localStorageKey),
    //       environment.secretkey
    //     ).toString(CryptoJS.enc.Utf8)
    //   );
    //   if (!this.userInfo.subscription_type) {
    //     this.toastr.warning("Please take subscription first."),
    //       {
    //         closeButton: true,
    //       };
    //   }
    // }
  }
  changeLanguage(translate: string) {
    this.language = translate;
    this.translate.use(translate);
    const language = translate;
    localStorage.setItem(
      environment.localStorageLangKey,
      JSON.stringify(language)
    );
  }

  navigateTo(element: string): any {
    this.activeStatus = element;
    this.Navigate.emit(element);
  }
}
